import React from "react";
import { Box } from "@mui/material";
import { HeaderInfo } from "../types";
import HeaderTabs from "./header_tabs";
import { TableLoader, TableResults } from "./table";

interface SearchResultsProps {
  isApiStartedCalling: boolean;
  resultAvailable: boolean | null;
  headersInfo: HeaderInfo[];
  onTabSelection: (header: HeaderInfo) => void;
  clearSelection: (header: HeaderInfo) => void;
  onScroll: (e: React.UIEvent) => void;
  onViewAllHandler: (header: HeaderInfo) => void;
  selectedTab: string;
  isScrollOn: boolean;
  handleClose?: () => void;
}

const SearchResults: React.FC<SearchResultsProps> = ({
  isApiStartedCalling,
  resultAvailable,
  headersInfo,
  clearSelection,
  onScroll,
  onViewAllHandler,
  selectedTab,
  isScrollOn = false,
  onTabSelection,
  handleClose,
}) => {
  const handleTabClick = (headerInfo: HeaderInfo) => {
    onTabSelection(headerInfo);
  };

  const handleTabClear = (headerInfo: HeaderInfo) => {
    clearSelection(headerInfo);
  };

  return (
    <Box className="search-results-content">
      {/* Header Tabs Section */}
      <HeaderTabs
        isLoading={isApiStartedCalling}
        resultAvailable={resultAvailable}
        headersInfo={headersInfo}
        selectedTab={selectedTab}
        onTabClick={handleTabClick}
        onTabClear={handleTabClear}
      />

      {/* Table Results Section */}
      {isApiStartedCalling ? (
        <TableLoader
          rowCount={selectedTab ? 12 : 6}
          tableCount={selectedTab ? 1 : 2}
        />
      ) : (
        resultAvailable && (
          <TableResults
            headersInfo={headersInfo}
            selectedTab={selectedTab}
            onScroll={onScroll}
            onViewAllHandler={onViewAllHandler}
            isScrollOn={isScrollOn}
            handleClose={handleClose}
          />
        )
      )}
    </Box>
  );
};

export default SearchResults;
